import { Result } from '@blade/std-lib'
import { loadScript } from '@root/shared/core/DomUtil'
import { LoadScriptError } from '@root/shared/core/script-loader/script-loader'

declare global {
  interface Window {
    bluesky?: Bluesky
  }
}

export interface Bluesky {
  scan: (node?: HTMLElement) => void
}

const blueskyWidgetJs = 'https://embed.bsky.app/static/embed.js'

let blueskyWidgetPromise:
  | Promise<Result.Result<Bluesky, LoadScriptError>>
  | undefined

export const loadBlueskyWidget = () => {
  if (blueskyWidgetPromise) {
    return blueskyWidgetPromise
  }

  blueskyWidgetPromise = new Promise<Result.Result<Bluesky, LoadScriptError>>(
    (resolve) => {
      loadScript(blueskyWidgetJs, {
        async: true,
      }).then((result) => {
        if (Result.isFailure(result)) {
          blueskyWidgetPromise = undefined
          resolve(Result.fail(result.failure))

          return
        }

        if (!window.bluesky) {
          resolve(
            Result.fail(
              new LoadScriptError({
                src: blueskyWidgetJs,
                cause: 'window.bluesky is undefined',
              }),
            ),
          )

          return
        }

        resolve(Result.succeed(window.bluesky))
      })
    },
  )

  return blueskyWidgetPromise
}
